import React from 'react'

const Programs = () => {
  return (
    <div style={{marginTop:'30px'}} className="container-fluid blog pb-5">
        <div className="container pb-5">
            <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth:'800px'}}>
                <h4 className="text-uppercase text-primary">Our Programs</h4>
                <h1 className="display-3 text-capitalize mb-3">See Our Current Programs</h1>
            </div>
            <div className="row g-4 justify-content-center">
                <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="blog-item">
                        <div className="blog-img">
                            <img src="img/online-learning.jpeg" className="img-fluid rounded-top w-100" alt="" />
                            {/* <!-- <div className="blog-date px-4 py-2"><i className="fa fa-calendar-alt me-1"></i> Jan 12 2025</div> --> */}
                        </div>
                        <div className="blog-content rounded-bottom p-4">
                            <a href="#" className="h4 d-inline-block mb-3">PHGEx Fellows Training Program</a>
                            <p>A Learning By Doing (LBD) approach(online and community-based) for digital entrepreneurship training & mentorship developed for the Youths, Women and PwDs</p>
                            <a href="#" className="fw-bold text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.4s">
                    <div className="blog-item">
                        <div className="blog-img">
                            <img src="img/ananse-logo.jpg" className="img-fluid rounded-top w-100" alt="" />
                            {/* <!-- <div className="blog-date px-4 py-2"><i className="fa fa-calendar-alt me-1"></i> Jan 12 2025</div> --> */}
                        </div>
                        <div className="blog-content rounded-bottom p-4">
                            <a href="#" className="h4 d-inline-block mb-3">Ananse Grassroot Innovation Network - Ghana Consortium</a>
                            <p>A vast network of solution builders across the length and breadth of Ghana, focusing on addressing the African Problem, the African Way.</p>
                            <a href="#" className="fw-bold text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.6s">
                    <div className="blog-item">
                        <div className="blog-img">
                            <img src="img/screening-agnes.jpg" className="img-fluid rounded-top w-100" alt="" />
                            {/* <!-- <div className="blog-date px-4 py-2"><i className="fa fa-calendar-alt me-1"></i> Jan 12 2025</div> --> */}
                        </div>
                        <div className="blog-content rounded-bottom p-4">
                            <a href="#" className="h4 d-inline-block mb-3">PHG DigiHealth & Wellness Programme (Community Outreach & Health Promotion)</a>
                            {/* <!-- <p>We </p> --> */}
                            <a href="#" className="fw-bold text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="blog-item">
                        <div className="blog-img">
                            <img src="img/agriinnovates.jpg" className="img-fluid rounded-top w-100" alt="" />
                            {/* <!-- <div className="blog-date px-4 py-2"><i className="fa fa-calendar-alt me-1"></i> Jan 12 2025</div> --> */}
                        </div>
                        <div className="blog-content rounded-bottom p-4">
                            <a href="#" className="h4 d-inline-block mb-3">AgriInnovates Fellows Training / Mentorship Programme </a>
                            <p>Cutting edge technology aided Agric Programs & Interventions for farmers & relevant stakeholders in the agric supply chain.</p>
                            <a href="#" className="fw-bold text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="blog-item">
                        <div className="blog-img">
                            <img src="img/responsible-ai.jpg" className="img-fluid rounded-top w-100" alt="" />
                            {/* <!-- <div className="blog-date px-4 py-2"><i className="fa fa-calendar-alt me-1"></i> Jan 12 2025</div> --> */}
                        </div>
                        <div className="blog-content rounded-bottom p-4">
                            <a href="#" className="h4 d-inline-block mb-3">PHG Responsible AI, Robotics & IoT Program </a>
                            <p>A team of Experts Brainstorming & pushing the Boundaries of what is possible in the realms of embedded systems & IoT.</p>
                            <a href="#" className="fw-bold text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="blog-item">
                        <div className="blog-img">
                            <img src="img/merbli.jpg" className="img-fluid rounded-top w-100" alt="" />
                            {/* <!-- <div className="blog-date px-4 py-2"><i className="fa fa-calendar-alt me-1"></i> Jan 12 2025</div> --> */}
                        </div>
                        <div className="blog-content rounded-bottom p-4">
                            <a href="#" className="h4 d-inline-block mb-3">Monitoring, Evaluation, Research and Behaviour Learning Insight(MERBLI)</a>
                            <p>Multi-disciplinary Team of Expert researchers, well vexed with research variables & conditions in the African setting. </p>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                {/* <!-- <a href="#" className="fw-bold text-secondary"><i className="fa fa-angle-left"></i> Sign Up </a> --> */}
                                <a href="#" className="fw-bold text-secondary">Read More <i className="fa fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  )
}

export default Programs